import CashierDetails from './CashierDetails';

export default CashierDetails;
